import React, { useState } from "react";
import { useLocation} from "react-router-dom";
import "../styles/Filters.css";

//used for slider
//https://www.kindacode.com/article/using-range-sliders-in-react

const Filters = ({ zipCode, updateZipCode, countyName, updateCountyName, 
    ageBracket, setAgeBracket, filters, setFilters, sortByLocation, 
    setSortByLocation, sliderValue,  setSliderValue}) => {

    const [localZipCode, setLocalZipCode] = useState(zipCode);
    const [localCountyName, setLocalCountyName] = useState(countyName);
    // const [sliderValue, setSliderValue] = useState(); // Default value

    const [validZip, setValidZip] = useState(zipCode ? true : false);
    const [validCounty, setValidCounty] = useState(countyName ? true : false);

    //Add location variable
    const location = useLocation();

    const handleZipChange = (e) => {

        setLocalZipCode(e.target.value);
    };

	const handleZipSubmit = () => {

        if(localZipCode.trim() === '' || !/^\d+$/.test(localZipCode)){

            setValidZip(false);
            updateZipCode('');
        }else{

            setValidZip(true);

            updateZipCode(localZipCode);
            //changes the display for county search parameter to blank 
            setLocalCountyName('');
            //changes the county name variable in local storage to ''
            updateCountyName('');
        }
	};

    // Added the County Name to Filters
    const handleCountyChange = (e) => {
        setLocalCountyName(e.target.value);
    };

    const handleCountySubmit = () => {

        if(localCountyName.trim() === '' || !/^[A-Za-z\s\-]+$/.test(localCountyName)){

            setValidCounty(false);
            updateCountyName('');
        }else{

            setValidCounty(true);
            updateCountyName(localCountyName);
            //changes the display for zip code search parameter to blank 
            setLocalZipCode('');
            //changes the zip code variable in local storage to ''
            updateZipCode('');            
        }
    }   

    //Add the SLider to Filters
    const handleSliderChange = (event) => {
        event.preventDefault();
        setSliderValue(Number(event.target.value));
        //console.log( e.target.value);
    };

    const handleAgeChange = (e) => {
        setAgeBracket(e.target.value);
        setFilters([]); // Clear other filters when age is selected
    };

	const handleCheckboxChange = (e) => {
		const { name, checked } = e.target;
		if (checked) {
			setFilters([name]);
			setAgeBracket(""); // Clear age bracket
		} else {
			setFilters([]); // Clear checkboxes if unchecked
		}
	};

	const handleToggleChange = (e) => {
		setSortByLocation((prev) => !prev);
	};

    //called by the "Reset Filters" button when clicked.
    //sets all the filters to null, except zip code or county
    const handleFiltersReset = () => {

        //sets the range slider to 0.
        setSliderValue(0);

        //sets the sort location toggle off.
        setSortByLocation(false);

        //changes the filters to null
        setFilters([]);

        //change the age brakcet to null
        //the result shange but need to chnage the next deisplayed in dropdown
        setAgeBracket("");
    } 

	return (
        <div className="Filters">

            <h2>Filters</h2>
			
			{/* County search */}
            <div className="zip-search">
                <p>Change County Name:</p>
                <div className="input-and-button">
                    <input
                        className="zip-input"
                        type="text"
                        placeholder="County Name"
                        value={localCountyName}
                        onChange={handleCountyChange}
                    />
                    <button className="zip-button" onClick={handleCountySubmit}>Enter</button>
                </div>

                {!validCounty && !countyName &&  (
                    <span>County must be only letters, paces, and hyphens</span>
                )}
            </div>   

			{/* ZIP search */}
			<div className="zip-search">
				<p>Change ZIP Code:</p>
				<div className="input-and-button">
					<input
						className="zip-input"
						type="text"
						placeholder="ZIP Code"
						value={localZipCode}
						onChange={handleZipChange}
					/>
					<button className="zip-button" onClick={handleZipSubmit}>
						Enter
					</button>
				</div>

                {!validZip && !zipCode && (
                    <span>ZipCode must be only numbers</span>
                )}
			</div>

            {/*sort by location*/}
            <div className="toggle-container">
                <label className="toggle-switch">
                    <input
                        type="checkbox"
                        checked={sortByLocation}
                        onChange={handleToggleChange}
                    />
                    <span className="slider"></span>
                </label>
                <span>Sort by Location</span>
            </div>

            {/* Set resources range */}
            {sortByLocation && <div>
                <text>Resource Search Range: {sliderValue}</text>
                <input
                    type="range"
                    min={0}
                    max={100}
                    step={10}
                    value={sliderValue}
                    onChange={handleSliderChange}
                />
                <br/><br/>
            </div>  }

            {/* Checkbox filters */}
            <div className="checkbox-filters">
                <p>Other Filters:</p>
                <label>
                    <input
                        type="checkbox"
                        name="veteran"
                        checked={filters.includes('veteran')}
                        onChange={handleCheckboxChange}
                    />
                    I am a veteran
                </label>
                <label>
                    <input
                        type="checkbox"
                        name="disability"
                        checked={filters.includes('disability')}
                        onChange={handleCheckboxChange}
                    />
                    I have a disability
                </label>
                <label>
                    <input
                        type="checkbox"
                        name="childWithDisability"
                        checked={filters.includes('childWithDisability')}
                        onChange={handleCheckboxChange}
                    />
                    I have a child with a disability
                </label>
            </div>

            {/* Dropdown filters */}
            <div className="dropdown-filters">
                <select
                    name="age-bracket" 
                    value={ageBracket}
                    onChange={handleAgeChange}
                >
                    <option value="" disabled>
                        Select Age Bracket
                    </option>
                    <option value="parent-8-under">Parent with children 8 & under</option>
                    <option value="parent-9-up">Parent with children 9 & up</option>
                    <option value="young-adult">18 - 24</option>
                    <option value="working-age-adult">25 - 64</option>
                    <option value="senior">65+</option>
                </select>
            </div>

            {/* Reset filters Button*/}
            <div>
                <button 
                   className="filters-reset" 
                   onClick={handleFiltersReset}
                >
                    Reset Filters
                </button>
            </div>

		</div>
    );
	
};

export default Filters;
